import { Component, OnInit } from '@angular/core';
import { FormGroupExt } from '../../../../form-ext/form-group.ext';
import { AbstractControl, Validators } from '@angular/forms';
import { FormBuilderExt } from '../../../../form-ext/form-builder.ext';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '../../../../../common-modules/services/toast.service';
import { UsersService } from '../../../users/services/users.service';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false,
})
export class ResetPasswordComponent implements OnInit {
    public formGroup: FormGroupExt;
    public passwordPlaceholder = $localize`New Password`;
    public confirmPasswordPlaceholder = $localize`Confirm New Password`;
    public isLoading = false;
    private token: string | null = null;

    constructor(
        public formBuilder: FormBuilderExt,
        protected readonly http: HttpClient,
        private route: ActivatedRoute,
        public router: Router,
        private toastService: ToastService,
        private usersService: UsersService,
        private authService: AuthService,
    ) {}

    public get PasswordControl(): AbstractControl | null {
        return this.formGroup?.group.get('password');
    }

    public get ConfirmPasswordControl(): AbstractControl | null {
        return this.formGroup?.group.get('confirmPassword');
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe(async (params) => {
            this.token = params['token'];
            if (!this.token) {
                this.toastService.showError('Missing reset token. Please check your reset link.', { duration: 3000 });
                await this.router.navigate(['/login']);
            }
        });

        this.formGroup = this.formBuilder.groupExt(
            {
                password: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/)]],
                confirmPassword: ['', Validators.required],
            },
            {
                validator: this.passwordMatchValidator,
            },
            {
                password: {
                    required: $localize`Password is required`,
                    minlength: $localize`Password must be at least 8 characters`,
                    pattern: $localize`Password must contain uppercase, lowercase, and numbers`,
                },
                confirmPassword: {
                    required: $localize`Confirm Password is required`,
                    passwordsNotMatching: $localize`Passwords do not match`,
                },
            },
        );
    }

    passwordMatchValidator(form: any) {
        const password = form.get('password')?.value;
        const confirmPassword = form.get('confirmPassword')?.value;

        if (password !== confirmPassword) {
            form.get('confirmPassword')?.setErrors({ passwordsNotMatching: true });
            return { passwordsNotMatching: true };
        }
        return null;
    }

    public resetPassword(): void {
        if (!this.formGroup.group.valid || !this.token) {
            return;
        }

        this.isLoading = true;

        this.usersService.changePassword(this.token, this.PasswordControl?.value).subscribe({
            next: async () => {
                this.toastService.showSuccess('Password reset successfully', { duration: 3000 });
                await this.router.navigate(['/login']);
            },
            error: (error) => {
                this.isLoading = false;
                this.toastService.showError(error?.message, { duration: 3000 });
            },
        });
    }
}
